exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__container___3ZQuV{display:grid;grid-template-columns:1fr 3fr;grid-template-rows:1fr;grid-gap:1rem}@media (max-width:525px){.index-module__container___3ZQuV{grid-template-columns:1fr}}@media (min-width:768px){.index-module__container___3ZQuV{grid-template-columns:1fr}}@media (min-width:1325px){.index-module__container___3ZQuV{grid-template-columns:1fr 3fr}}.index-module__container___3ZQuV .index-module__item___2QkG9{width:100%}.index-module__container___3ZQuV .index-module__item___2QkG9 .index-module__date___12aKW{color:#707070;font-size:18px;font-weight:500;padding:1rem}.index-module__container___3ZQuV .index-module__item___2QkG9 .index-module__no-events___1YIdx{color:#707070;font-size:32px;font-weight:500;display:flex;justify-content:center;padding:1rem}", ""]);

// exports
exports.locals = {
	"container": "index-module__container___3ZQuV",
	"item": "index-module__item___2QkG9",
	"date": "index-module__date___12aKW",
	"no-events": "index-module__no-events___1YIdx"
};